module.exports = __webpack_public_path__ + "static/media/FI.64375f65.png";